import {type CreatePaymentMethodP24Data} from '@stripe/stripe-js';
import {type StripeGateway, type IStripeContext} from '../../../models/stripe';
import {PeachPayCustomer} from '../../../reducers/peachPayCustomerReducer';
import {getLocaleText} from '../../../util/translation';
import p24BadgeURL from '../../../../img/badge/p24.svg';
import p24ImageURL from '../../../../img/marks/p24.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initStripeP24Method(): StripeGateway {
	return {
		config: {
			name: Feature.metadata<string>(FeatureFlag.STRIPE_P24_GATEWAY, 'title') ?? 'Przelewy24',
			gatewayId: 'peachpay_stripe_p24',
			description: getLocaleText('After selecting <b>Pay</b> you will be redirected to complete your payment.'),
			assets: {
				title: {src: p24ImageURL},
				badge: {src: p24BadgeURL},
			},
		},
		async tokenize(context) {
			const {stripe} = context;

			const {paymentMethod, error} = await stripe.createPaymentMethod({
				type: 'p24',
				billing_details: PeachPayCustomer.stripeBillingDetails(),
			} as unknown as CreatePaymentMethodP24Data);

			if (error) {
				const message = error.message ?? 'Failed to tokenize payment method.';

				return [null, {
					paymentStatus: 'creationfailed',
					note: message,
				}];
			}

			if (!paymentMethod?.id) {
				return [null, {
					paymentStatus: 'creationfailed',
					note: 'Failed to tokenize payment method.',
				}];
			}

			return [paymentMethod.id, {}];
		},
		async confirm(context: IStripeContext, clientSecret: string, intermediateURL: string) {
			const {stripe} = context;

			const {paymentIntent, error} = await stripe.confirmP24Payment(clientSecret, {return_url: intermediateURL});

			if (error) {
				const message = error.message ?? 'Failed to confirm payment.';
				return [null, {
					note: message,
				}];
			}

			if (paymentIntent) {
				return ['success', {}];
			}

			return [null, {}];
		},
	};
}

export {initStripeP24Method};
